export enum ESampleStatus {
    Code = 1,
    EnMesure = 2,
    Confirme = 3,
    Valide = 4
}